// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LightningGradientFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M11.998 31.305c0-.449.195-.928.584-1.437L32.999 4.375c.374-.48.779-.771 1.213-.876.45-.105.846-.06 1.19.134.36.18.607.48.742.899.15.42.112.913-.113 1.482l-6.693 18.194h12.69c.48 0 .869.15 1.168.449.3.284.45.644.45 1.078 0 .464-.195.943-.584 1.438L22.645 52.688c-.375.464-.787.749-1.236.854-.434.12-.83.082-1.19-.113-.345-.18-.592-.479-.742-.898-.134-.42-.09-.921.135-1.505l6.694-18.193h-12.69c-.48 0-.87-.143-1.169-.427-.3-.3-.449-.666-.449-1.1Z"
			fill="url(#LightningGradientFilled_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="LightningGradientFilled_tsx__a"
				x1={5.333}
				y1={0.917}
				x2={59.244}
				y2={45.026}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F39871" />
				<stop offset={1} stopColor="#F0D975" />
			</linearGradient>
		</defs>
	</svg>
);
export default LightningGradientFilled;
